export const IS_NETWORK_CONNECTED = "IS_NETWORK_CONNECTED@common";
export const SHOW_APPLE_INSTALLATION_INFO = "SHOW_APPLE_INSTALLATION_INFO@common";
export const REHYDRATE_WITH_SESSION_STORAGE = "REHYDRATE_WITH_SESSION_STORAGE@common";
export const FETCH_OSPEDALI = "FETCH_OSPEDALI@common";
export const FETCH_OSPEDALI_SUCCESS = "FETCH_OSPEDALI_SUCCESS@common";
export const SET_PRIVACY_ACCEPTED = "SET_PRIVACY_ACCEPTED@common";
